export default __webpack_public_path__ + "static/media/1808.57e13c9e.png";